import React, { useState, useEffect } from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const generateLighterColors = (count) => {
  const colors = [];
  for (let i = 0; i < count; i++) {
    colors.push(`hsl(${(i * 360) / count}, 80%, 60%)`);
  }
  return colors;
};

const Portfolio = ({ loggedInUserId }) => {
  const userHoldings = {
    '74fa9d1fe62900729c057e37f4241c2217ea678501c60334808391161a01507b': [
      { coin: "bitcoin", amount: 0.2, investedPrice: 37426.5 },
      { coin: "ethereum", amount: 3.25, investedPrice: 2343.24 },
      { coin: "solana", amount: 25, investedPrice: 117.5 },
      { coin: "chainlink", amount: 52, investedPrice: 16.4 },
      { coin: "uniswap", amount: 75, investedPrice: 6.24 },
      { coin: "near", amount: 250, investedPrice: 3.936 },
      { coin: "tether", amount: 1200, investedPrice: 1 },
    ],
    '3867deec0cc9d459e47970652ecf123f4671b667352c8fb992a00990402ec074': [
      { coin: "tether", amount: 1000, investedPrice: 1 },
    ],
    user3: [
      { coin: "litecoin", amount: 10, investedPrice: 150 },
      { coin: "ripple", amount: 2500, investedPrice: 0.5 },
    ],
  };

  const loggedInUser = localStorage.getItem("username") || "default";
  const [holdings, setHoldings] = useState(
    userHoldings[loggedInUser] || [
      { coin: "bitcoin", amount: 0, investedPrice: 0 },
    ]
  );
  const [prices, setPrices] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchPrices = async () => {
      try {
        const response = await fetch(
          "https://api.coingecko.com/api/v3/coins/markets?vs_currency=usd"
        );
        const data = await response.json();
        const priceData = {};
        data.forEach((coin) => {
          priceData[coin.id] = coin.current_price;
        });
        setPrices(priceData);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching prices:", error);
      }
    };

    fetchPrices();
  }, []);

  const updatedHoldings = holdings.map((h) => {
    const currentPrice = prices[h.coin] || 0;
    const totalInvested = h.amount * h.investedPrice;
    const totalCurrent = h.amount * currentPrice;
    const profitLossPercent = totalInvested
      ? ((totalCurrent - totalInvested) / totalInvested) * 100
      : 0;
    const profitLossAmount = totalCurrent - totalInvested;

    return {
      ...h,
      currentPrice,
      totalInvested,
      totalCurrent,
      profitLossPercent,
      profitLossAmount,
    };
  });

  const dynamicColors = generateLighterColors(updatedHoldings.length);

  const holdingAmountData = {
    labels: updatedHoldings.map((h) => h.coin),
    datasets: [
      {
        data: updatedHoldings.map((h) => h.amount),
        backgroundColor: dynamicColors,
        hoverOffset: 4,
      },
    ],
  };

  const holdingValueData = {
    labels: updatedHoldings.map((h) => h.coin),
    datasets: [
      {
        data: updatedHoldings.map((h) => h.totalCurrent),
        backgroundColor: dynamicColors,
        hoverOffset: 4,
      },
    ],
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="portfolio-container">
      <h2>{loggedInUser}'s Portfolio</h2>
      <div className="portfolio-content">
        <div className="charts">
          <div className="chart">
            <h3>Holdings by Coins</h3>
            <Pie data={holdingAmountData} options={{ maintainAspectRatio: true }} />
          </div>
          <div className="chart">
            <h3>Holdings by Value</h3>
            <Pie data={holdingValueData} options={{ maintainAspectRatio: true }} />
          </div>
        </div>
        <div className="portfolio-table-wrapper">
          <table className="portfolio-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Invested Price (USD)</th>
                <th>Current Price (USD)</th>
                <th>Coins</th>
                <th>Total Invested (USD)</th>
                <th>Total Current (USD)</th>
                <th>P&L %</th>
                <th>P&L Amount (USD)</th>
              </tr>
            </thead>
            <tbody>
              {updatedHoldings.map((h) => (
                <tr key={h.coin}>
                  <td>{h.coin.charAt(0).toUpperCase() + h.coin.slice(1)}</td>
                  <td>${h.investedPrice.toLocaleString()}</td>
                  <td>${h.currentPrice.toLocaleString()}</td>
                  <td>{h.amount}</td>
                  <td>${h.totalInvested.toLocaleString()}</td>
                  <td>${h.totalCurrent.toLocaleString()}</td>
                  <td
                    style={{
                      color: h.profitLossPercent >= 0 ? "green" : "red",
                    }}
                  >
                    {h.profitLossPercent.toFixed(2)}%
                  </td>
                  <td
                    style={{
                      color: h.profitLossAmount >= 0 ? "green" : "red",
                    }}
                  >
                    ${h.profitLossAmount.toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Portfolio;
